import type { ReactElement } from 'react';

export function DisclosureChevron({ direction }: { readonly direction: 'up' | 'down' }): ReactElement {
  const path = direction === 'up' ? 'M6 15l6-6 6 6' : 'M6 9l6 6 6-6';
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"
      fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
      <path d={path} />
    </svg>
  );
}
